/* eslint-disable require-jsdoc */

export class PdfNodeBase {
	constructor(_UUID) {
		this.UUID = _UUID;
	}
}
